import React from 'react';
import { motion } from 'framer-motion';
export function CostOfNotBuyingSection() {
  const rows = [{
    without: 'Seguir pagando deudas que ya prescribieron',
    cost: 'Miles de pesos tirados a la basura'
  }, {
    without: 'Rechazos en bancos sin entender por qué',
    cost: 'Oportunidades de crédito perdidas para siempre'
  }, {
    without: 'Acoso de estudios de cobranza constante',
    cost: 'Estrés, ansiedad y desgaste emocional'
  }, {
    without: 'Esperar que el Veraz se limpie solo',
    cost: '5+ años más bloqueado del sistema financiero'
  }, {
    without: 'Consultar un abogado',
    cost: '$50.000+ en honorarios sin garantía de resultado'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-47">
      <div className="max-w-3xl mx-auto w-full flex flex-col items-center" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-49">
          <div className="text-brand-gold text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-50">
            La realidad sin acción
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-51">
            ¿Cuánto cuesta <span className="text-brand-gold" data-id="element-52">no tenerlo</span>?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full rounded-xl overflow-hidden mb-8 shadow-[0_0_30px_rgba(201,168,76,0.03)]" style={{
        border: '1px solid rgba(201, 168, 76, 0.12)',
        background: 'linear-gradient(180deg, #0c0b08 0%, #080808 100%)'
      }} data-id="element-53">
          <div className="grid grid-cols-2" style={{
          background: 'linear-gradient(90deg, #0d0b08 0%, #12100a 50%, #0d0b08 100%)',
          borderBottom: '1px solid rgba(201, 168, 76, 0.12)'
        }} data-id="element-54">
            <div className="px-4 py-3 sm:px-5 sm:py-3.5 font-bold text-gray-500 text-center text-xs uppercase tracking-wider" data-id="element-55">
              Sin el MegaPack
            </div>
            <div className="px-4 py-3 sm:px-5 sm:py-3.5 font-bold text-brand-gold text-center text-xs uppercase tracking-wider border-l border-brand-gold/8" data-id="element-56">
              Costo real
            </div>
          </div>

          {rows.map((row, index) => <div key={index} className="grid grid-cols-2 transition-colors duration-200 hover:bg-brand-gold/[0.02]" style={{
          borderBottom: index < rows.length - 1 ? '1px solid rgba(255,255,255,0.03)' : 'none',
          background: index % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)'
        }} data-id="element-57">
              <div className="px-4 py-3 sm:px-5 sm:py-3.5 text-gray-500 text-xs sm:text-sm flex items-center justify-center text-center leading-snug" data-id="element-58">
                {row.without}
              </div>
              <div className="px-4 py-3 sm:px-5 sm:py-3.5 text-white/90 font-medium text-xs sm:text-sm flex items-center justify-center text-center border-l border-white/[0.03] leading-snug" data-id="element-59">
                {row.cost}
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-60">
          <p className="text-sm sm:text-base text-gray-400 mb-1" data-id="element-61">
            Tu próximo paso puede cambiar todo.
          </p>
          <p className="text-sm sm:text-base font-semibold text-brand-gold/80 italic" data-id="element-62">
            "La ley 25.326 ya está de tu lado."
          </p>
        </motion.div>
      </div>
    </section>;
}